import { connect } from "react-redux";
import { compose } from "recompose";
import { closeWizard } from "../duck/actions";
import { getInitialStep } from "../duck/selectors";
import { withFrame } from "src/components/Frame/Context";
import Wizard from "./Wizard";
import withRouter from "src/routing/withRouter";
import { withApp } from "src/components/App/Context";

function mapStateToProps(state) {
  return {
    initialStep: getInitialStep(state)
  };
}

export default compose(withFrame, withRouter, withApp, connect(mapStateToProps, { closeWizard }))(Wizard);
